import { LeaseCarDataPricePoint, LeaseCarDurations } from 'types';

export const getGroupedPricePoints = (pricePoints: LeaseCarDataPricePoint[]): LeaseCarDurations => {
	const basePrice = pricePoints.reduce((prev, curr) =>
		prev.pricePerMonth < curr.pricePerMonth ? prev : curr
	).pricePerMonth;

	const allMonths = pricePoints.map((pricePoint) => pricePoint.duration).sort((a, b) => a - b);
	const uniqueMonthsSorted = new Set(allMonths);

	const durations: LeaseCarDurations = {};

	uniqueMonthsSorted.forEach((month) => {
		const pricePointsForMonth = pricePoints.filter((pricePoint) => pricePoint.duration === month);

		const lowestPrice = pricePointsForMonth.reduce((prev, curr) =>
			prev.pricePerMonth < curr.pricePerMonth ? prev : curr
		).pricePerMonth;

		durations[month] = {
			price: lowestPrice - basePrice,
			name: month.toString(),
			kilometrages: pricePointsForMonth.map((pricePoint) => ({
				description: pricePoint.description,
				duration: pricePoint.duration,
				id: pricePoint.id,
				mileage: pricePoint.mileage,
				pricePerMonth: pricePoint.pricePerMonth - lowestPrice,
			})),
		};
	});
	return durations;
};
